import React, { useEffect, useRef } from 'react';
import { FeatureFlag } from 'site-modules/shared/components/feature-flag/feature-flag';
import PropTypes from 'prop-types';
import { get } from 'lodash';

export function ExcoVideo({ id, excoProps, customTargeting }) {
  const excoRef = useRef();
  const EXCO_SCRIPT_TAG_ID = 'exco-video-init';
  const { mobile, edwcat, edwpg, edw, vid, zip, mk, mdl, sub, year, doNotSell, usPrivacy, sect1, sect2 } = excoProps;

  const customTargetingObj = customTargeting && JSON.parse(customTargeting);
  const customParams = {
    ...customTargetingObj,
    mobile,
    edwcat,
    edwpg,
    edw,
    vid,
    zip,
    mk,
    mdl,
    sub,
    year,
    doNotSell,
    us_privacy: usPrivacy,
    sect1,
    sect2,
  };
  const dataExsConfig = { customParams };

  useEffect(() => {
    if (get(excoRef, 'current')) {
      const head = document.head;
      if (document.getElementById(EXCO_SCRIPT_TAG_ID)) {
        head.removeChild(document.getElementById(EXCO_SCRIPT_TAG_ID));
      }
      const script = document.createElement('script');
      const innerScript = `(function(d,s,n){var js,fjs=d.getElementsByTagName(s)[0];js=d.createElement(s);js.className=n;js.src="//player.ex.co/player/${id}";fjs.parentNode.insertBefore(js,fjs);}(document,"script","exco-player"));`;

      script.textContent = innerScript;
      script.async = true;
      script.id = EXCO_SCRIPT_TAG_ID;
      head.appendChild(script);
      return () => {
        head.removeChild(script);
      };
    }
    return undefined;
  }, [id]);
  return (
    <FeatureFlag name="enableExco">
      <div
        id={id}
        ref={excoRef}
        className="heading-4 pb-1 exco-player"
        data-exs-config={JSON.stringify(dataExsConfig).replace(/"/g, '\\"')}
      >
        <span className="pb-0_5 d-block">Testing EX.CO</span>
      </div>
    </FeatureFlag>
  );
}

ExcoVideo.propTypes = {
  id: PropTypes.string.isRequired,
  excoProps: PropTypes.shape({
    mobile: PropTypes.bool,
    edwcat: PropTypes.string,
    edwpg: PropTypes.string,
    edw: PropTypes.string,
    vid: PropTypes.string,
    zip: PropTypes.string,
    mk: PropTypes.string,
    mdl: PropTypes.string,
    sub: PropTypes.string,
    year: PropTypes.string,
    doNotSell: PropTypes.bool,
    usPrivacy: PropTypes.string,
    sect1: PropTypes.string,
    sect2: PropTypes.string,
  }).isRequired,
  customTargeting: PropTypes.string,
};
ExcoVideo.defaultProps = {
  customTargeting: null,
};
